import * as moment from 'moment'

export function formatDatesRanges(rangeDates: Date[]) {
  function parseDate(date: moment.Moment) {
    return date.format('YYYY-MM-DD HH:mm:ss')
  }
  if (rangeDates) {
    const momentRangeDates = rangeDates
      .map((d) => moment(d))
      .filter((d) => d.isValid())
    if (momentRangeDates.length === 2) {
      return {
        createdAt__gte: parseDate(momentRangeDates[0].startOf('D')),
        createdAt__lte: parseDate(momentRangeDates[1].endOf('D')),
      }
    }

    if (momentRangeDates.length === 1) {
      return {
        createdAt__gte: parseDate(momentRangeDates[0].startOf('D')),
        createdAt__lte: parseDate(momentRangeDates[0].endOf('D')),
      }
    }
  }
  return ''
}
